const getPropertyElementId = (name) => `hc-image-property-${name}`;

const createPropertyElement = (name) => {
  const imgInputContainer = document.createElement("DIV");
  imgInputContainer.innerHTML = `<input type='hidden' id="${getPropertyElementId(
    name,
  )}" name="properties[_${name}]" />`;
  const imgInput = imgInputContainer.querySelector("input");
  document.querySelector(".product-form").append(imgInput);
  return imgInput;
};

const createImageThumbnail = (src) => {
  const img = document.createElement("IMG");
  img.src = src;
  img.style.width = "100%";
  img.style.height = "auto";
  img.id = "hc-image-thumbnail";
  return img;
};

const createImageThumbnailContainer = () => {
    const imageContainer = document.createElement("DIV");
    imageContainer.classList.add("product__custom-media-item");
    imageContainer.addEventListener("click", () => {
      const parentImage = imageContainer.parentImage;
      if (parentImage) {
        console.log('clicking parent image', parentImage);
        parentImage.click();
      }
    });
    return imageContainer;
}

const getOrCreatePropertyElement = (name) =>
  document.querySelector(`#${getPropertyElementId(name)}`) ||
  createPropertyElement(name);

let oldImageBefore = null;
const updateOrAddImageThumbnail = (src, parentImage) => {
  let img = document.querySelector("#hc-image-thumbnail");
  if (img && img.src === src) return;
  if (!img) img = createImageThumbnail(src);
  img.remove();
  img.src = src;
  let imageContainer = document.querySelector(".product__custom-media-item");
  if (!imageContainer) imageContainer = createImageThumbnailContainer();
  imageContainer.innerHTML = '';
  imageContainer.parentImage = parentImage;

  let imageBefore = document.querySelector("#infiniteoptions-container");
  // Find the latest :not[disabled] div with a content that has model inside imageBefore
  setTimeout(() => {
    const modelOption = imageBefore.querySelector(
      'div:not([disabled]) > .spb-label-tooltip > label:is([for*="model"], [for*="Model"])',
    );
    imageBefore = modelOption
      ? modelOption.closest("div:not(.spb-label-tooltip)")
      : imageBefore;

    oldImageBefore = imageBefore;

    // Get the previous element before imageBefore
    imageContainer.append(img);
    const infiniteContainer = imageBefore.closest('#infiniteoptions-container');
    // Find the dev that contains Brand in the <select[name]>
    const brandOption = infiniteContainer.querySelector('div:not([disabled]) > select:is([name*="brand"], [name*="Brand"])');
    const brandName = brandOption ? brandOption.value : '';

    imageName = `${brandName} - ${imageBefore.querySelector("select").value}`;
    const imageNameElements = document.createElement("span");
    imageNameElements.innerHTML = imageName;
    imageNameElements.classList.add("product__custom-media-item-name");
    imageContainer.append(imageNameElements);
    const price = imageBefore.closest('.product__meta').querySelector('[data-price]').innerText;
    const priceElement = document.createElement("span");
    priceElement.classList.add("product__custom-media-item-price");
    priceElement.innerHTML = price;
    imageContainer.append(priceElement);
    imageBefore.after(imageContainer);
  });
};

document.body.addEventListener("change", (e) => {
  let io;
  if ((io = e.target.closest("#infiniteoptions-container"))) {
    const imageContainer = document.querySelector(".product__custom-media-item");
    if (imageContainer) {
      imageContainer.remove();
    }
    setTimeout(() => {
      const options = [...io.querySelectorAll("select:not([disabled])")].map(
        (el) => [
          el.name.replace(/properties\[(.+)\]$/gi, "$1").toLowerCase(),
          el.value,
        ],
      );
      const images = [
        ...document.querySelectorAll(".product__media-item .image img"),
      ].map((el) => [el.alt, el.src, el]);
      const image = images.find((image) => {
        let match = true;
        for (const option of options) {
          if (
            !image[0].match(new RegExp(`${option[0]}\\:${option[1]}\\;`, "i"))
          )
            match = false;
        }
        return match;
      });
      if (!image) {
        // Remove the image thumbnail if an image element exists
        oldImageBefore.querySelector("select").value = "";
        return;
      }
      const imgSrc = image[1];
      const ImgInput = getOrCreatePropertyElement("altImg");
      ImgInput.value = imgSrc;

      updateOrAddImageThumbnail(imgSrc, image[2]);
    }, 300);
  }
});
